import React from "react";
import { useAppDispatch } from "common/hooks/storeHooks";
import { RemoteStorageContext } from "common/components/RemoteStorage/RemoteStorageContext";
import { RemoteStorageService, remoteStorageCallback } from "common/api/remoteStorage.service";
import { RemoteStorageSession } from "common/components/RemoteStorage/RemoteStorageSession";
import {
  clearRemoteStorage,
  getRemoteStorage,
  setRemoteStorage,
} from "common/components/RemoteStorage/remoteStorageRegistry";

interface RemoteStorageProviderProps {
  children: React.ReactNode;
}

export const RemoteStorageProvider: React.FC<RemoteStorageProviderProps> = ({ children }) => {
  const dispatch = useAppDispatch();

  const remoteStorage = React.useMemo(() => {
    const published = getRemoteStorage();
    if (published instanceof RemoteStorageService) return published;

    const created = new RemoteStorageService({
      callbacks: [remoteStorageCallback],
      onError: () => {},
      onTimeout: () => {},
      dispatch: dispatch,
    });
    setRemoteStorage(created);

    return created;
  }, [dispatch]);

  React.useEffect(() => {
    setRemoteStorage(remoteStorage);

    return () => clearRemoteStorage(remoteStorage);
  }, [remoteStorage]);

  return (
    <RemoteStorageContext.Provider
      value={{
        remoteStorage,
      }}>
      <RemoteStorageSession></RemoteStorageSession>
      {children}
    </RemoteStorageContext.Provider>
  );
};
